import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { UploadStatus } from '../UploadStatus';
const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: theme.shape.borderRadius,
        width: '100%',
    },
    filesList: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        margin: theme.spacing(1, 2, 2),
        maxWidth: 'calc(100% - 130px)', // Adjusted to not overlap with the action buttons
    },
}));
/**
 * ChatAttachments component displays the attachments of each chat message.
 */
export const ChatAttachments = ({ files, progress, onRemove }) => {
    const classes = useStyles();
    return (_jsx(Paper, { className: classes.root, elevation: 0, children: _jsx(Box, { className: classes.filesList, children: files &&
                files.length &&
                files.map((file, index) => (_jsx(UploadStatus, { file: file, progress: progress, onRemove: () => onRemove(index), errors: [] }, `${file.name}-${index}`))) }) }));
};
export default ChatAttachments;
